import SwiperCore, {Pagination} from 'swiper/core';
import 'swiper/swiper-bundle.css';


export class BlockProducts {
    constructor() {

        ///////////////////EXECUTE INITIALS FUNCTIONS///////////////////////

        this.swiperInit()
        this.touchpointImp()
        this.selectGallerySlide()

        ///////////////////////

    }


    ///////////////////////SWIPER INIT///////////////////////

    //upper swiper init
    swiperInit(){

        let that = this

        SwiperCore.use([Pagination]);
        this.upperSwiper = new SwiperCore('.block__products__track', {
            spaceBetween: 10,
            pagination: {
                el: '.block__products__paginator',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"> 0' + (index + 1) + "</span>";
                }
            },
            noSwiping: true,
            noSwipingClass: 'swiper-slide'
        });

        function isMobile() {
            return window.matchMedia('(max-width: 767px)').matches;
        }
        if (isMobile()) {
            const lowerSwiper = window.lowerSwiper = new SwiperCore('.block__products__gallery__container', {
                spaceBetween: 35,
                slidesPerView: 1.17
            })
        }

        ///////////////////////TRANSITION FUNCTIONS///////////////////////

        //when slide changes, refresh touchpoints and variables for gallery swiper
        this.upperSwiper.on('slideChange', function refreshFunctions() {
            console.log('im transitioning, as you know')
            that.touchpointImp()
            that.selectGallerySlide()
        })

        //change gallery when upper slide changes
        this.upperSwiper.on('activeIndexChange', function changeGallery() {
            let activeIndexSlide = that.upperSwiper.activeIndex
            let galleryPositionBoxList = document.querySelectorAll('.block__products__gallery__position-box')
            let galleryContainerList = document.querySelectorAll('.block__products__gallery__container')
            console.log('whats active slide index?', activeIndexSlide)
            console.log('whats active gallery?', galleryPositionBoxList[activeIndexSlide])

            let activeGalleryPositionBox = galleryPositionBoxList[activeIndexSlide]
            let activeGalleryContainer = activeGalleryPositionBox.querySelector('.block__products__gallery__container')

            for (let i = 0; i < galleryPositionBoxList.length; i++) {
                galleryPositionBoxList[i].classList.remove('active-gallery-position-box')
                galleryContainerList[i].classList.remove('active-gallery-container')
            }

            activeGalleryPositionBox.classList.add('active-gallery-position-box')

            console.log('whats active position box?', activeGalleryPositionBox)

            activeGalleryContainer.classList.add('active-gallery-container')
        })

        ///////////////////////

    }

    ///////////////////////

    ///////////////////////USED FUNCTIONS DECLARATIONS///////////////////////

    //auto swipe gallery list until selected
    autoSwipeGallery(myLoopVariable) {

        function isMobile() {
            return window.matchMedia('(max-width: 767px)').matches;
        }
        function isTablet() {
            return window.matchMedia('(min-width: 768px) and (max-width: 1023px)').matches;
        }

        //normal scrolling (too fast)
        //document.querySelector('.block__products__gallery').scrollIntoView({behavior: 'smooth', block: 'end'})


        let myGallery = document.querySelector('.block__products__gallery');
        let myGalleryValues = myGallery.getBoundingClientRect();
        let myGalleryTopValue = myGalleryValues.top

        console.log('myGalleryPos', myGalleryTopValue)

        let myGalleryAbsolutePos = (myGalleryTopValue + window.pageYOffset) - (window.innerHeight - myGallery.offsetHeight);

        function slowScrolling() {
            let scrollingInterval = setInterval(function(){
                if (window.pageYOffset < myGalleryAbsolutePos){
                    if (isMobile()){
                        window.scrollBy({
                                top: 15,
                                behavior: 'auto'
                            }
                        )
                        //console.log('first the window and then the element', window.pageYOffset, myGalleryAbsolutePos)
                    } else if(isTablet()){
                        window.scrollBy({
                                top: 18,
                                behavior: 'auto'
                            }
                        )
                    } else {
                        window.scrollBy({
                                top: 28,
                                behavior: 'auto'
                            }
                        )
                        //console.log('first the window and then the element', window.pageYOffset, myGalleryAbsolutePos)
                    }
                } else {
                    {
                        clearInterval(scrollingInterval)
                    }
                }

            },17)

        }
        slowScrolling();


        console.log('gallery is auto-swiping, as expected')

        let activeIndexSlide = this.upperSwiper.activeIndex

        if (isMobile()) {
            console.log('whats active gallery container?', lowerSwiper[activeIndexSlide])
            lowerSwiper[activeIndexSlide].slideTo(myLoopVariable, 700)
        }

    }

    //touchpoints implementation
    touchpointImp() {
        let that = this

        let topList = document.querySelectorAll('.block__products__slide')
        let topActiveSlideIndex = topList[that.upperSwiper.activeIndex]
        console.log('this is active slide for touchpoints', topActiveSlideIndex)

        let touchpointArray = topActiveSlideIndex.querySelectorAll('.touchpoint_element')
        for (let i = 0; i < touchpointArray.length; i++) {

            touchpointArray[i].onclick = function (e) {
                console.log('touchpoint clicked')

                let parent = e.target.parentElement
                let action = 'unknown'
                if (parent) {
                    let link = parent.querySelector('.block__products__slide__take-a-look')
                    action = link.getAttribute("href")
                }

                if (window.dataLayer) {
                    console.log('datalayer pushing touchpoint')
                    let dataLayer = window.dataLayer
                    dataLayer.push({
                        'event': "collections",
                        'eventCategory': "collection",
                        'eventAction': action,
                        'eventLabel': ''
                    })
                }

                let myGallery = document.querySelector('.active-gallery-container');
                let mySpecGallery = myGallery.querySelector('.block__products__gallery__list');
                let myGallerySlide = mySpecGallery.querySelector('.swiper-slide-active')

                let gallerySlideList = mySpecGallery.querySelectorAll('.block__products__gallery-slide')

                myGallerySlide.classList.remove('swiper-slide-active');
                gallerySlideList[i].classList.add('swiper-slide-active');


                that.autoSwipeGallery(i, touchpointArray)

            }
        }
    }

    //activate slide when clicked on with mouse
    selectGallerySlide() {

        let that = this

        let myActiveGallery = document.querySelector('.active-gallery-position-box')
        let myProductGallery = myActiveGallery.querySelector('.block__products__gallery__list')
        let slideList = myProductGallery.querySelectorAll('.block__products__gallery-slide')

        for (let i = 0; i < slideList.length; i++) {
            slideList[i].onclick = function () {
                console.log('you clicked a gallery slide!')


                let myActiveSlide = myProductGallery.querySelector('.swiper-slide-active')

                myActiveSlide.classList.remove('swiper-slide-active')
                slideList[i].classList.add('swiper-slide-active')

                that.autoSwipeGallery(i, slideList)

            }
        }
    }

    ///////////////////////


}





